<template>
  <!---------------------------------------------------------------------
    공통 : common
  ----------------------------------------------------------------------->
  <article class="common">
    <div class="scroll">
      <!-- <contents-header
        :titleText="true"
        :bgType="true"
        :title="$t('MOTP-FRT-03-01-01-13')/*사고신고 내역조회*/"
      ></contents-header>-->
      <article class="contents">
        <!-- tab content -->

        <div class="form">
          <!-- -->
          <div class="form-row">
            <div class="item-tit">
              {{ /* 사고 조회 계좌번호*/ $t("MACD-01-06-04") }}
              <sup class="point">*</sup>
            </div>
            <div class="item-desc">
              <div class="form-select-field">
                <acno-select-box
                  ref="accountSelectBox"
                  in-acn-knd="1"
                  in-acn-dtl-knd="1"
                  :value.sync="selectedAcno"
                  :detailValue.sync="selectedAcnoDetail"
                  @change="acnoChange"
                  required
                />
              </div>
            </div>
          </div>
          <!-- -->
        </div>
        <!-- notice -->
        <div class="notice notice-box--type">
          <div class="notice-tit">{{ /* 유의사항*/ $t("MPRS-01-01-01-04") }}</div>
          <div class="notice-cont">
            <ul class="ulist bar-bullet">
              <li>{{ /*10년 이내의 내역만 조회하실 수 있습니다*/ $t("MACD-01-06-05") }}</li>
              <li>
                {{ /*신고사항의 해제는 영업점에서 본인확인 후에 가능하므로
                신분증(기업 고개의 경우 법인 관련 서류)을 지참하시고 영업점에
                방문하셔서 서면으로 신청하셔야 합니다.*/ $t("MACD-01-03-12") }}
              </li>
            </ul>
          </div>
        </div>
        <!--// end -->
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md normal" @click="goNext">{{$t('MPRS-02-02-13-06')/**조회*/}}</button>
    </div>

    <!--// end -->

    <!-- modal -->
    <modal-pop :opened.sync="type" :modalHeader="true" :modalFooter="true" class="modal">
      <template #content>
        <div>
          인터넷뱅킹을 비롯하여 모든 전자금융 사고신고 내역까지 조회하실 수
          있습니다.
        </div>
        <div>10년 이내의 내역만 조회하실 수 있습니다.</div>
        <div>
          신고사항의 해제를 위해서는 영업점에서 본인확인 후에 가능하므로 신분증
          (기업 고객의 경우 법인 관련 서류)을 지참하시고 영업점에 방문하셔서
          서면으로 신청하시기 바랍니다.
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="type = !type">확인</button>
      </template>
    </modal-pop>
    <!-- end -->
  </article>
</template>
<style type="scss" scoped></style>
<script>
// import CommonGrid from "@/components/page/common/CommonGrid";
// import ContentsHeader from "@/components/page/common/ContentsHeader.vue";
import AcnoSelectBox from "@/components/page/common/AcnoSelectBox";
import { mapFields } from "vuex-map-fields";
//import AccountList from "@/components/page/customer/account.vue";
import { mapActions } from "vuex";

// const INQUERY_DST = "0"; //0 : 계좌, 1 : 인터넷

export default {
  name: "foreign",
  components: {
    // ContentsHeader,
    AcnoSelectBox,
    //AccountList,
    // CommonGrid,
  },
  computed: {
    ...mapFields("customer/suppStore", ["reportList", "acnoInfo"]),
    ...mapFields(["sessionInfo"]),
  },
  data() {
    return {
      type: false,

      currentTab: 0,
      tabs: ["계좌/현금/직불카드", "인터넷"],
      selectedAcno: "",
      selectedAcnoDetail: "",
      info: {
        acno: "", //계좌번호
        alias: "", //별칭
        acnDsticCd: "", //계좌종류
        ovsesCustOcntryName: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(["actSetError"]),
    acnoChange(data) {
      // this.$log.info("22222========>", data);
      this.$set(this.info, "acno", data.acno); //계좌정보 저장.
      this.$set(this.info, "alias", data.alias); //계좌정보 저장.
      this.$set(this.info, "ovsesCustOcntryName", data.ovsesCustOcntryName);
    },
    goNext() {
      this.$refs.accountSelectBox.$refs.acno.$v.$touch();

      if (this.$refs.accountSelectBox.$refs.acno.$v.$invalid) {
        return false;
      }

      this.acnoInfo = this.info;
      this.$router.push({ name: "reportsInquiry2" });
    },
  },
};
</script>
